import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Icon } from '../icon';

const meta = {
  argTypes: {
    icon: { table: { disable: true } },
    size: { table: { disable: true } },
    strokeWidth: { table: { disable: true } },
  },
  args: {
    icon: 'calendar-check',
    size: '',
    strokeWidth: '',
  },
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Icon/',
};

interface Story {
  icon: Icon['icon'];
  size: Icon['size'];
  strokeWidth: Icon['strokeWidth'];
}

const story = ({ icon, size, strokeWidth }: Partial<Story>) => html`
  <abds-icon
    icon="${ifDefined(icon || undefined)}"
    size="${ifDefined(size || undefined)}"
    stroke-width="${ifDefined(strokeWidth || undefined)}"
  ></abds-icon>
`;

export { meta, story };
